import { Box } from "@mui/material";
import theme from "src/theme";

type Props = {
  faillure: number;
  success: number;
};
export function ProportionChart({ faillure, success }: Props) {
  const total = faillure + success;

  const failWidth = `${(faillure / total) * 100}%`;
  const successWidth = `${(success / total) * 100}%`;

  return <Box sx={styles.container}>
    <Box sx={{ ...styles.blocks.base, ...styles.blocks.success, width: successWidth }}></Box>
    <Box sx={{ ...styles.blocks.base, ...styles.blocks.fail, width: failWidth }}></Box>
  </Box>;
}

const styles = {
  container: {
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.grey[600],
    height: "20px"
  },
  blocks: {
    base: {
      heigth: "100%"
    },
    fail: {
      backgroundColor: theme.palette.error.main
    },
    success: {
      backgroundColor: theme.palette.success.main
    }
  }
}